'use client';

import * as React from "react";
import { Dialog } from "radix-ui";
import "./styles.css";
import { Cross2Icon } from "@radix-ui/react-icons";
import { Label } from "../label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../select";
import { Input } from "../input";
import { Button } from "../button";

export default function DialogBox(props:any) {
    const { handleDialogBox, handleNewComments, bucketsList } = props;
    const [isOpen, setIsOpen] = React.useState(false);
    const [comment, setComment] = React.useState('');
    const [selBucket, setSelBucket] = React.useState('');
    
    React.useEffect(()=>{
        console.log(props.isOpen);
        setIsOpen(props.isOpen);
    },[props.isOpen]);

    const handleFormSubmit = (e:any) => {
        e.preventDefault();
        setIsOpen(false);
        handleDialogBox(false);
        handleNewComments(comment, selBucket);
        console.log(comment);
    };

    const handleDialogClose = () => {
        setIsOpen(false);
        handleDialogBox(false);
    }

    const handleComment = (e:any) => {
        setComment(e.target.value);
    }

    const handleSelectedBucket = (value:any) => {
        setSelBucket(value);
        console.log(value);
    };
    
    return (
        <div>
            <Dialog.Root open={isOpen}>
                <Dialog.Trigger />
                <Dialog.Portal>
                    <Dialog.Overlay className="DialogOverlay" />
                    <Dialog.Content className="DialogContent">
                        <form onSubmit={handleFormSubmit} className="py-3">
                            <div className='mb-2 inline-block w-full'>
                                <Label htmlFor='newComment' className='text-sm'>Add a New Comment: </Label>
                                <Input type='input' id='newComment' name='newComment' className='mt-1 bg-gray-200 text-gray-700 border-gray-300 placeholder-gray-400 w-full' onChange={handleComment}/>
                            </div>
                            <div className='mb-2 mr-3 inline-block w-full'>
                                <Label className='text-sm ml-1'>Select Bucket: </Label>
                                <Select
                                    onValueChange={(value: any) =>
                                    handleSelectedBucket(value)
                                    } 
                                >
                                    <SelectTrigger className="w-full bg-white border-gray-300 text-gray text-[14px]">
                                    <SelectValue placeholder="Select bucket" />
                                    </SelectTrigger>
                                    <SelectContent>
                                    {bucketsList && bucketsList
                                        .filter((b: any) => b)
                                        .map((bucket: any, bIndex: React.Key | null | undefined) => (
                                        <SelectItem key={bIndex} value={bucket.name}>
                                            {bucket.name}
                                        </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            </div>
                            <div className="text-right">
                                <input type="submit" className="cursor-pointer px-4 py-1 rounded-md bg-transparent custom-bg-mbooth text-white border-[0px]" />
                            </div>
                        </form>
                        
                            <Dialog.Close asChild>
                                <Button className="IconButton bg-black p-0" aria-label="Close" onClick={handleDialogClose}>
                                    <Cross2Icon />
                                </Button>
                            </Dialog.Close>
                        
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        </div>
    )
}